import { UserManagementPage } from "../components/UserManagement";

export function UserManagementComponent() {
  return <UserManagementPage />;
}
